import { call, delay, put, select } from "redux-saga/effects";
import { getVersion } from "./service";
import { setCurrentVersion, showUpdateAvailable } from "./actions";

export default function* VersionSaga() {

    while (true) {
        try {
            const latest = yield call(getVersion);
            const installed = yield select(
                state => state.Version.currentVersion
            );

            if (!installed) {
                yield put(setCurrentVersion(latest.version));
            } else if (latest.version !== installed) {
                yield put(showUpdateAvailable());
                return;
            }
        } catch (e) {
            console.error(e);
        }

        yield delay(5 * 60 * 1000);
    }
}